export default "__VITE_ASSET__3Tm0o5Vs__"